import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { useWebChat } from "../../context";
import useLocalStorage from 'react-use-localstorage';
import Bubble from "../Bubble";
import locales from "../../locales";
import { ButtonMinimize, SrOnly } from "../../styledComponents";
import MinimizeIcon from "../../icons/MinimizeIcon";

const StyledStaticOnboarding = styled.div`
  width: 349px;
  background: #077AC0;
  border-radius: 24px;
  position: fixed;
  right: 60px;
  bottom: 34px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  backdrop-filter: blur(10px);
  box-shadow: 0 0 1.25em rgba(0, 0, 0, 0.2);
`;

const StyledWrapper = styled.div`
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 18px;
`;

const StyledTitle = styled.h2`
  font-family: Open Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.2px;
  color: white;
  margin-bottom: 6px;
  margin-top: 44px;
`;

const SytledParagraph = styled.p`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #FFFFFF !important;
  padding-bottom: 26px;
`;

const StyledButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 17px 21px;
  background: #FFFFFF;
  border-radius: 4px;
  width: 100%;
  margin-bottom: 8px;
  color: #077AC0;
  font-family: Open Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  border: 2px solid #FFFFFF;

  &:hover {
    background-color: var(--color-primary) !important;
    color: var(--color-white) !important;
    border-color: var(--color-white) !important;
  }
`;

const OnboardingMinimizeButton = styled(ButtonMinimize)`
  height: 52px;
`

const Onboarding = ({ qnaUrl = '', kn = '', lang = 'fr-ca' }) => {
  const [ isFirstOnboardingView, setIsFirstOnboardingView] = useLocalStorage('isFirstOnboardingView', 'true');
  const [isOnboardingVisible, setIsFirstOnboardingVisible] = useState();
  const { handleMaximizeButtonClick, setTab, setSpinnerDisplayed } = useWebChat();
  const isMobile = window.matchMedia('(max-width: 768px)');

  useEffect(() => {
    if (isFirstOnboardingView === 'true' && !isMobile.matches) {
      setIsFirstOnboardingVisible(true);
      setIsFirstOnboardingView('false')
    }
  }, [setIsFirstOnboardingVisible, isFirstOnboardingView, setIsFirstOnboardingView, isMobile]);

  const handleMinimize = () => {
    setIsFirstOnboardingVisible(false);
  }

  const handleOnboardClick = () => {
    handleMaximizeButtonClick();
    setIsFirstOnboardingVisible(false);
  }

  const handleFaqClick = () => {
    setTab(false);
    setSpinnerDisplayed(true);
    handleOnboardClick();
  }

  return (
    <>
      {isOnboardingVisible && !isMobile.matches ?
        <StyledStaticOnboarding>
          <OnboardingMinimizeButton onClick={handleMinimize}>
            <MinimizeIcon />
            <SrOnly>{locales(lang, 'closeChat')}</SrOnly>
          </OnboardingMinimizeButton>
          <StyledWrapper>
            <StyledTitle>{locales(lang, 'hello')}</StyledTitle>
            <SytledParagraph>
              {locales(lang, 'onboardingWelcome')}
            </SytledParagraph>

            <StyledButton onClick={handleOnboardClick}>
              {locales(lang, 'startBtn')}
            </StyledButton>

            <StyledButton onClick={handleFaqClick}>
              {locales(lang, 'seeFaqBtn')}
            </StyledButton>
          </StyledWrapper>
        </StyledStaticOnboarding>
        : <Bubble qnaUrl={qnaUrl} lang={lang} kn={kn} />
      }
    </>
  )
}

export default Onboarding;
